import React from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { Button } from "@material-ui/core";

const Li = styled.li`
  ${({ theme: { colors }, desktop, active, isDisabled }) => `
    position: relative;
    display: flex;
    padding: 5px 10px;
    min-height: ${desktop ? "80px" : null};
    transition: all .2s ease-in-out;
    z-index: 10;
    color: ${colors.white};
    

    ${
      !desktop &&
      `
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `
    }

    ${
      !isDisabled &&
      `
      &:hover {
        &:after {
          top: 0;
          height: 100%;
        }
      }
    `
    }
  `}
`;

const StyledButton = styled(Button)`
  z-index: 11;
`;

const NavItem = ({ to, children, isDisabled, desktop, toggleDrawer }) => {
  const history = useHistory();
  return (
    <Li
      desktop={desktop}
      isDisabled={isDisabled}
      active={history.location.pathname.includes(to)}
    >
      <StyledButton
        color="inherit"
        onClick={() => {
          history.push(to);
          !desktop && toggleDrawer();
        }}
        disabled={isDisabled}
      >
        {children}
      </StyledButton>
    </Li>
  );
};

export default NavItem;
